import request from '@/config/request'

export default {
    searchAsset: function (customerCode) {
        return request({
            url: '/dashboard/asset/searchasset',
            method: 'post',
            params: {
                customercode: customerCode
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/dashboard/asset.js